import * as React from 'react';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';


export default function BackdropLoader({
  open = false,
  text=""
}) {
  // for progress loader
  // const [progress, setProgress] = React.useState(0);
  React.useEffect(() => {
    const timer = setInterval(() => {
      // setProgress((prevProgress) => (prevProgress >= 100 ? 0 : prevProgress + 10));
    }, 800);

    return () => {
      clearInterval(timer);
    };
  }, []);
//end progress loader

  return (
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
        // onClick={handleClose}
      >
       
     
       <CircularProgress color="inherit" />
     {/* <Typography sx={{margin:"2px 10px"}}>{text}</Typography> */}
     
      
      </Backdrop>
  );
}